












import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: 'AsideTools'
})
export default class AsideTools extends Vue {
  @Prop({
    type: String,
    default: null
  })
  icon;

  @Prop({
    type: String,
    default: null
  })
  label;

  @Prop({
    type: Boolean,
    default: false
  })
  hasClose;

  close() {
    this.$emit('close')
  }
}
